import React from 'react';

const Disclaimer2 = () => {

	return (
		<p className="disclaimer disclaimer2">Plan inclusions, prices and promotional offers advertised may not be available at all addresses. This service qualification address check is only a preliminary result of plans and prices available in your area. Please note that the result may vary, together with plans, prices and promotions available at your address, as we process your order and connection.</p>
	);

};

export default Disclaimer2;


// WEBPACK FOOTER //
// ./resources/assets/js/elements/Disclaimer2.js